import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'empresas/anuncios/';

/**
 * GET Anuncios
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getAnuncios = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Anuncio
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getAnuncio = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Anuncio
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postAnuncio = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Anuncio
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchAnuncio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Anuncio
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteAnuncio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
